import AccommodationState from '@/types/store/AccommodationState';

const state: AccommodationState = {
  accommodations: [],
};

export default state;
